import React, { useEffect, useState, useContext, useRef } from "react";
import { LoadingModalContext, MessagePopupContext } from "../../ServicePage";
import {
  addPageToConfluence,
  getAllConfluenceSpaces,
  overwriteConfluencePage,
} from "../../../../services/webServices";
import PageTitleModal from "../../../common-components/PageTitleModal";
import ConfluenceSpacesComponentPage from "../../../common-components/ConfluenceSpacesComponentPage ";

const ConfluenceSelectionPage = ({
  issueType,
  taskType,
  setConfluencePageOpen,
  exportData,
  confluenceConfig,
  setProceedingApp,
}) => {
  const { setMessagePopup, setMessage } = useContext(MessagePopupContext);
  const { setLoadingState } = useContext(LoadingModalContext);

  const [spacesList, setSpacesList] = useState([]);
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [importLoading, setImportLoading] = useState(null);

  const [pageTitle, setPageTitle] = useState("");
  const [pageTitleModalOpen, setPageTitleModalOpen] = useState(true);
  const [workspaceChoice, setWorkspaceChoice] = useState("");
  const [existingChoice, setExistingChoice] = useState("");

  const didFetch = useRef(false);

  // fetch spaces
  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    const fetchSpaces = async () => {
      setImportLoading("Spaces");
      try {
        const response = await getAllConfluenceSpaces();
        setSpacesList(response.data || []);
      } catch (err) {
        const errMsg =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Failed to fetch Confluence spaces.";
        setMessage(errMsg);
        setMessagePopup(true);
      } finally {
        setImportLoading(null);
      }
    };
    fetchSpaces();
  }, []);

  const splitLines = (val) =>
    Array.isArray(val) ? val : typeof val === "string" ? val.split("\n") : [];

  // export function
  // const exportToConfluence = async (space, options = {}) => {
  //   setLoadingState({
  //     open: true,
  //     message: "Exporting to Confluence",
  //     progress: null,
  //   });

  //   try {
  //     let contentHtml = "";

  //     // Differentiate by issueType
  //     if (
  //       issueType === "Bugs" &&
  //       Array.isArray(exportData) &&
  //       exportData.length > 0
  //     ) {
  //       // Generate Bug Content
  //       const bugContent = exportData
  //         .map((bug) => {
  //           return `
  //           <h1>${bug.Title || ""}</h1>
  //           <p><strong>Description:</strong> ${bug.Description || ""}</p>

  //           <h3>Steps To Reproduce:</h3>
  //           <ol>
  //             ${splitLines(bug.Steps_To_Reproduce)
  //               .map((step) => `<li>${step.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Expected vs Actual Behavior:</h3>
  //           ${(() => {
  //             if (typeof bug.Expected_Vs_Actual_Behavior === "string") {
  //               const parts = bug.Expected_Vs_Actual_Behavior.split("\n");
  //               return `
  //                 <p><strong>Expected:</strong> ${parts[0] || ""}</p>
  //                 <p><strong>Actual:</strong> ${parts[1] || ""}</p>
  //               `;
  //             }
  //             return `
  //               <p><strong>Expected:</strong> ${
  //                 bug.Expected_Vs_Actual_Behavior?.Expected || ""
  //               }</p>
  //               <p><strong>Actual:</strong> ${
  //                 bug.Expected_Vs_Actual_Behavior?.Actual || ""
  //               }</p>
  //             `;
  //           })()}

  //           <h3>Evidences (TBD):</h3>
  //           <ol>
  //             ${splitLines(bug.Evidences_TBD)
  //               .map(
  //                 (evidence) => `<li>${evidence.replace(/^\d+\.\s*/, "")}</li>`
  //               )
  //               .join("")}
  //           </ol>

  //           <h3>Business Impact:</h3>
  //           <p>${bug.Business_Impact || ""}</p>

  //           <h3>Technical Impact:</h3>
  //           <p>${bug.Technical_Impact || ""}</p>

  //           <h3>Severity Level:</h3>
  //           <p>${bug.Severity_Level || ""}</p>

  //           <h3>Workaround:</h3>
  //           <ol>
  //             ${splitLines(bug.Workaround)
  //               .map((w) => `<li>${w.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Possible Causes for Defect Leakage:</h3>
  //           <ol>
  //             ${splitLines(bug.Possible_Causes_For_Defect_Leakage)
  //               .map((cause) => `<li>${cause.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Ideal Test Case:</h3>
  //           ${(() => {
  //             if (typeof bug.Ideal_Test_Case === "string") {
  //               return `<pre>${bug.Ideal_Test_Case}</pre>`;
  //             }
  //             return `
  //               <p><strong>Test Case ID:</strong> ${
  //                 bug.Ideal_Test_Case?.Test_Case_ID || ""
  //               }</p>
  //               <p><strong>Title:</strong> ${
  //                 bug.Ideal_Test_Case?.Title || ""
  //               }</p>
  //               <p><strong>Objective:</strong> ${
  //                 bug.Ideal_Test_Case?.Objective || ""
  //               }</p>
  //               <p><strong>Preconditions:</strong> ${
  //                 bug.Ideal_Test_Case?.Preconditions || ""
  //               }</p>

  //               <h4>Test Steps:</h4>
  //               <ol>
  //                 ${splitLines(bug.Ideal_Test_Case?.Test_Steps)
  //                   .map((step) => `<li>${step.replace(/^\d+\.\s*/, "")}</li>`)
  //                   .join("")}
  //               </ol>

  //               <p><strong>Expected Result:</strong> ${
  //                 bug.Ideal_Test_Case?.Expected_Result || ""
  //               }</p>
  //               <p><strong>Pass/Fail Criteria:</strong> ${
  //                 bug.Ideal_Test_Case?.Pass_Fail_Criteria || ""
  //               }</p>
  //               <p><strong>Priority:</strong> ${
  //                 bug.Ideal_Test_Case?.Priority || ""
  //               }</p>
  //               <p><strong>Execution Environment:</strong> ${
  //                 bug.Ideal_Test_Case?.Execution_Environment || ""
  //               }</p>
  //             `;
  //           })()}

  //           <h3>Possible Causes for Dev Team:</h3>
  //           <ol>
  //             ${splitLines(bug.Possible_Causes_For_Dev_Team)
  //               .map((cause) => `<li>${cause.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Recommended Fixes for Dev Team:</h3>
  //           <ol>
  //             ${splitLines(bug.Recommended_Fixes_For_Dev_Team)
  //               .map((fix) => `<li>${fix.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Similar Bugs:</h3>
  //           <p>${bug.Similar_Bugs || ""}</p>

  //           <h3>Additional Information:</h3>
  //           <p>${bug.Additional_Information || ""}</p>

  //           <h3>Validation and Verification Retesting:</h3>
  //           <ol>
  //             ${splitLines(bug.Validation_And_Verification_Retesting)
  //               .map((item) => `<li>${item.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>

  //           <h3>Contextual Use Cases and Scenarios:</h3>
  //           <ol>
  //             ${splitLines(bug.Contextual_Use_Cases_And_Scenarios)
  //               .map((item) => `<li>${item.replace(/^\d+\.\s*/, "")}</li>`)
  //               .join("")}
  //           </ol>
  //         `;
  //         })
  //         .join("<hr/>");

  //       contentHtml += bugContent;
  //     } else if (
  //       issueType === "Business Process Guide" &&
  //       Array.isArray(exportData) &&
  //       exportData.length > 0
  //       // console.log("exportData", exportData );
  //     ) {
  //       // Generate Business Process Guide Content
  //       exportData.forEach((uc, index) => {
  //         const businessProcess = uc.parsedBuinessProcess;
  //         if (!businessProcess) return;

  //         const userContentHtml = `
  //         <h1>Business Process Guide ${
  //           exportData.length > 1 ? `- Use Case ${index + 1}` : ""
  //         }</h1>
  //         <p>${businessProcess["Description of the Business Process"] || ""}</p>

  //         <h2>Flow Chart</h2>
  //         ${
  //           uc.flowchartResponse
  //             ? `<div style="text-align: center; margin: 20px 0;">
  //                  <img src="data:image/svg+xml;base64,${btoa(
  //                    uc.flowchartResponse
  //                  )}"
  //                       alt="Business Process Flowchart"
  //                       style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; padding: 10px;" />
  //                </div>`
  //             : "<p>Flowchart not available.</p>"
  //         }

  //         <h2>Common Defects</h2>
  //         ${
  //           businessProcess["List of Common Defects"]?.length > 0
  //             ? `
  //               <table border="1" style="border-collapse: collapse; width: 100%;">
  //                 <thead>
  //                   <tr>
  //                     <th style="padding: 8px; background-color: #f5f5f5;">Defect</th>
  //                     <th style="padding: 8px; background-color: #f5f5f5;">Occurrence</th>
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   ${businessProcess["List of Common Defects"]
  //                     .map(
  //                       (defect) => `
  //                       <tr>
  //                         <td style="padding: 8px;">${defect.Defect || ""}</td>
  //                         <td style="padding: 8px;">${
  //                           defect.Occurrence || ""
  //                         }</td>
  //                       </tr>`
  //                     )
  //                     .join("")}
  //                 </tbody>
  //               </table>`
  //             : "<p>No common defects identified.</p>"
  //         }

  //         <h2>Glossary</h2>
  //         ${
  //           businessProcess.Appendix
  //             ? `
  //               <table border="1" style="border-collapse: collapse; width: 100%;">
  //                 <thead>
  //                   <tr>
  //                     <th style="padding: 8px; background-color: #f5f5f5;">Term</th>
  //                     <th style="padding: 8px; background-color: #f5f5f5;">Explanation</th>
  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   ${Object.entries(businessProcess.Appendix)
  //                     .map(
  //                       ([term, definition]) => `
  //                         <tr>
  //                           <td style="padding: 8px;">${term}</td>
  //                           <td style="padding: 8px;">${definition}</td>
  //                         </tr>`
  //                     )
  //                     .join("")}
  //                 </tbody>
  //               </table>`
  //             : "<p>No glossary available.</p>"
  //         }
  //       `;

  //         console.log("userContentHtml", userContentHtml);
  //         contentHtml += userContentHtml;
  //       });
  //     }
  //     console.log("Generated Content HTML:", contentHtml);

  //     // If nothing generated
  //     if (!contentHtml) {
  //       contentHtml = "<p>No content available for export.</p>";
  //     }

  //     // Build payload
  //     let payload;
  //     if (options.overwrite && options.pageId) {
  //       payload = {
  //         pageId: options.pageId,
  //         title: options.title,
  //         spaceKey: space.key,
  //         content: contentHtml,
  //       };
  //       await overwriteConfluencePage(payload);
  //     } else {
  //       payload = {
  //         spaceKey: space.key,
  //         pages: [{ title: options.title || pageTitle, content: contentHtml }],
  //       };
  //       await addPageToConfluence(payload);
  //     }

  //     setMessage(
  //       options.overwrite
  //         ? "Page updated successfully!"
  //         : "Page created successfully!"
  //     );
  //     setMessagePopup(true);
  //     setConfluencePageOpen(false);
  //   } catch (error) {
  //     const errMsg =
  //       error.response?.data?.message ||
  //       error.response?.data?.error ||
  //       "Failed to create/update Confluence page.";
  //     setMessage(errMsg);
  //     setMessagePopup(true);
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };
  // export function
  const exportToConfluence = async (space, options = {}) => {
    setLoadingState({
      open: true,
      message: "Exporting to Confluence",
      progress: null,
    });

    try {
      let contentHtml = "";

      // Add debug logging

      // Differentiate by issueType
      if (
        issueType === "Bugs" &&
        Array.isArray(exportData) &&
        exportData.length > 0
      ) {
        // Generate Bug Content
        const bugContent = exportData
          .map((bug) => {
            return `
          <h1>${bug.Title || ""}</h1>
          <p><strong>Description:</strong> ${bug.Description || ""}</p>

          <h3>Steps To Reproduce:</h3>
          <ol>
            ${splitLines(bug.Steps_To_Reproduce)
              .map((step) => `<li>${step.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Expected vs Actual Behavior:</h3>
          ${(() => {
            if (typeof bug.Expected_Vs_Actual_Behavior === "string") {
              const parts = bug.Expected_Vs_Actual_Behavior.split("\n");
              return `
                <p><strong>Expected:</strong> ${parts[0] || ""}</p>
                <p><strong>Actual:</strong> ${parts[1] || ""}</p>
              `;
            }
            return `
              <p><strong>Expected:</strong> ${
                bug.Expected_Vs_Actual_Behavior?.Expected || ""
              }</p>
              <p><strong>Actual:</strong> ${
                bug.Expected_Vs_Actual_Behavior?.Actual || ""
              }</p>
            `;
          })()}

          <h3>Evidences (TBD):</h3>
          <ol>
            ${splitLines(bug.Evidences_TBD)
              .map(
                (evidence) => `<li>${evidence.replace(/^\d+\.\s*/, "")}</li>`
              )
              .join("")}
          </ol>

          <h3>Business Impact:</h3>
          <p>${bug.Business_Impact || ""}</p>

          <h3>Technical Impact:</h3>
          <p>${bug.Technical_Impact || ""}</p>

          <h3>Severity Level:</h3>
          <p>${bug.Severity_Level || ""}</p>

          <h3>Workaround:</h3>
          <ol>
            ${splitLines(bug.Workaround)
              .map((w) => `<li>${w.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Possible Causes for Defect Leakage:</h3>
          <ol>
            ${splitLines(bug.Possible_Causes_For_Defect_Leakage)
              .map((cause) => `<li>${cause.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Ideal Test Case:</h3>
          ${(() => {
            if (typeof bug.Ideal_Test_Case === "string") {
              return `<pre>${bug.Ideal_Test_Case}</pre>`;
            }
            return `
              <p><strong>Test Case ID:</strong> ${
                bug.Ideal_Test_Case?.Test_Case_ID || ""
              }</p>
              <p><strong>Title:</strong> ${bug.Ideal_Test_Case?.Title || ""}</p>
              <p><strong>Objective:</strong> ${
                bug.Ideal_Test_Case?.Objective || ""
              }</p>
              <p><strong>Preconditions:</strong> ${
                bug.Ideal_Test_Case?.Preconditions || ""
              }</p>

              <h4>Test Steps:</h4>
              <ol>
                ${splitLines(bug.Ideal_Test_Case?.Test_Steps)
                  .map((step) => `<li>${step.replace(/^\d+\.\s*/, "")}</li>`)
                  .join("")}
              </ol>

              <p><strong>Expected Result:</strong> ${
                bug.Ideal_Test_Case?.Expected_Result || ""
              }</p>
              <p><strong>Pass/Fail Criteria:</strong> ${
                bug.Ideal_Test_Case?.Pass_Fail_Criteria || ""
              }</p>
              <p><strong>Priority:</strong> ${
                bug.Ideal_Test_Case?.Priority || ""
              }</p>
              <p><strong>Execution Environment:</strong> ${
                bug.Ideal_Test_Case?.Execution_Environment || ""
              }</p>
            `;
          })()}

          <h3>Possible Causes for Dev Team:</h3>
          <ol>
            ${splitLines(bug.Possible_Causes_For_Dev_Team)
              .map((cause) => `<li>${cause.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Recommended Fixes for Dev Team:</h3>
          <ol>
            ${splitLines(bug.Recommended_Fixes_For_Dev_Team)
              .map((fix) => `<li>${fix.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Similar Bugs:</h3>
          <p>${bug.Similar_Bugs || ""}</p>

          <h3>Additional Information:</h3>
          <p>${bug.Additional_Information || ""}</p>

          <h3>Validation and Verification Retesting:</h3>
          <ol>
            ${splitLines(bug.Validation_And_Verification_Retesting)
              .map((item) => `<li>${item.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>

          <h3>Contextual Use Cases and Scenarios:</h3>
          <ol>
            ${splitLines(bug.Contextual_Use_Cases_And_Scenarios)
              .map((item) => `<li>${item.replace(/^\d+\.\s*/, "")}</li>`)
              .join("")}
          </ol>
        `;
          })
          .join("<hr/>");

        contentHtml += bugContent;
      } else if (issueType === "Business Process Guide") {
        // Fixed: Removed malformed condition and console.log

        // Handle different possible data structures
        let processData = null;

        if (Array.isArray(exportData) && exportData.length > 0) {
          // If exportData is an array, iterate through it
          exportData
            .filter((uc) => uc != null) // Remove null/undefined entries
            .forEach((uc, index) => {
              const businessProcess = uc.parsedBuinessProcess;
              if (!businessProcess) return;

              const userContentHtml = generateBusinessProcessHTML(
                uc,
                businessProcess,
                index,
                exportData.length
              );
              contentHtml += userContentHtml;
            });
        } else if (exportData && exportData.businessProcessData) {
          // Handle single object with businessProcessData structure
          const businessProcess =
            exportData.businessProcessData.parsedBuinessProcess;
          if (businessProcess) {
            const userContentHtml = generateBusinessProcessHTML(
              exportData.businessProcessData,
              businessProcess,
              0,
              1
            );
            contentHtml += userContentHtml;
          }
        } else {
          console.warn(
            "Unrecognized data structure for Business Process Guide"
          );
        }
      }

      // If nothing generated
      if (!contentHtml) {
        contentHtml = "<p>No content available for export.</p>";
      }

      // Build payload
      let payload;
      if (options.overwrite && options.pageId) {
        payload = {
          pageId: options.pageId,
          title: options.title,
          spaceKey: space.key,
          content: contentHtml,
        };
        await overwriteConfluencePage(payload);
      } else {
        payload = {
          spaceKey: space.key,
          pages: [{ title: options.title || pageTitle, content: contentHtml }],
        };
        await addPageToConfluence(payload);
      }

      setMessage(
        options.overwrite
          ? "Page updated successfully!"
          : "Page created successfully!"
      );

      setMessagePopup(true);
      setConfluencePageOpen(false);
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to create/update Confluence page.";
      setMessage(errMsg);
      setMessagePopup(true);
      setConfluencePageOpen(false);
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  // Helper function to generate Business Process HTML
  function generateBusinessProcessHTML(uc, businessProcess, index, totalCount) {
    return `
    <h1>Business Process Guide ${
      totalCount > 1 ? `- Use Case ${index + 1}` : ""
    }</h1>
    <p>${businessProcess["Description of the Business Process"] || ""}</p>

    <h2>Flow Chart</h2>
    ${
      uc.flowchartResponse
        ? `<div style="text-align: center; margin: 20px 0;">
             <img src="data:image/svg+xml;base64,${btoa(uc.flowchartResponse)}" 
                  alt="Business Process Flowchart" 
                  style="max-width: 100%; height: auto; border: 1px solid #ccc; border-radius: 8px; padding: 10px;" />
           </div>`
        : "<p>Flowchart not available.</p>"
    }

    <h2>Common Defects</h2>
    ${
      businessProcess["List of Common Defects"]?.length > 0
        ? `
          <table border="1" style="border-collapse: collapse; width: 100%;">
            <thead>
              <tr>
                <th style="padding: 8px; background-color: #f5f5f5;">Defect</th>
                <th style="padding: 8px; background-color: #f5f5f5;">Occurrence</th>
              </tr>
            </thead>
            <tbody>
              ${businessProcess["List of Common Defects"]
                .map(
                  (defect) => `
                  <tr>
                    <td style="padding: 8px;">${defect.Defect || ""}</td>
                    <td style="padding: 8px;">${defect.Occurrence || ""}</td>
                  </tr>`
                )
                .join("")}
            </tbody>
          </table>`
        : "<p>No common defects identified.</p>"
    }

    <h2>Glossary</h2>
    ${
      businessProcess.Appendix
        ? `
          <table border="1" style="border-collapse: collapse; width: 100%;">
            <thead>
              <tr>
                <th style="padding: 8px; background-color: #f5f5f5;">Term</th>
                <th style="padding: 8px; background-color: #f5f5f5;">Explanation</th>
              </tr>
            </thead>
            <tbody>
              ${Object.entries(businessProcess.Appendix)
                .map(
                  ([term, definition]) => `
                    <tr>
                      <td style="padding: 8px;">${term}</td>
                      <td style="padding: 8px;">${definition}</td>
                    </tr>`
                )
                .join("")}
            </tbody>
          </table>`
        : "<p>No glossary available.</p>"
    }
  `;
  }
  const handleSavePageTitle = async () => {
    if (workspaceChoice === "new") {
      setPageTitleModalOpen(false);
      return;
    }

    if (workspaceChoice === "existing" && existingChoice === "overwrite") {
      // Overwrite the existing page in the existing space
      const space = { key: confluenceConfig.spaceKey };
      await exportToConfluence(space, {
        pageId: confluenceConfig.pageId,
        title: confluenceConfig.pageTitle,
        overwrite: true,
      });
    } else if (workspaceChoice === "existing" && existingChoice === "addnew") {
      // Add a new page in the same space
      const space = { key: confluenceConfig.spaceKey };
      await exportToConfluence(space, {
        pageId: null,
        title: pageTitle || "New Page",
        overwrite: false,
      });
    }
  };

  const handleSelectSpace = async (space) => {
    try {
      setSelectedSpace(space);
      await exportToConfluence(space);
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to export page to Confluence.";
      setMessage(errMsg);
      setMessagePopup(true);
    }
  };

  return (
    <>
      <PageTitleModal
        importToolAvailable={
          !!confluenceConfig &&
          confluenceConfig.toolName === "Confluence" &&
          confluenceConfig.issueType === issueType
        }
        issueType={issueType}
        taskType="Export"
        onSave={handleSavePageTitle}
        pageTitle={pageTitle}
        setPageTitle={setPageTitle}
        saveLoading={false}
        setSelectedSpace={setSelectedSpace}
        workspaceChoice={workspaceChoice}
        setWorkspaceChoice={setWorkspaceChoice}
        existingChoice={existingChoice}
        setExistingChoice={setExistingChoice}
        setPreviousSelection={setProceedingApp}
        pageTitleModalOpen={pageTitleModalOpen}
        setPageTitleModalOpen={setPageTitleModalOpen}
        setConfluencePageOpen={setConfluencePageOpen}
      />

      {!pageTitleModalOpen && workspaceChoice === "new" && !selectedSpace && (
        <ConfluenceSpacesComponentPage
          issueType={issueType}
          taskType="Export"
          spacesList={spacesList}
          spacesLoading={importLoading === "Spaces"}
          selectedSpace={selectedSpace}
          setSelectedSpace={handleSelectSpace}
          setConfluencePageOpen={setConfluencePageOpen}
          pageTitleModalOpen={pageTitleModalOpen}
          setPageTitleModalOpen={setPageTitleModalOpen}
          setWorkspaceChoice={setWorkspaceChoice}
          setExistingChoice={setExistingChoice}
          setPageTitle={setPageTitle}
          saveLoading={false}
        />
      )}
    </>
  );
};

export default ConfluenceSelectionPage;
